import { useContext, useState } from 'react'

import ExitToApp from '@material-ui/icons/ExitToApp'
import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import Files from './Files'
import { Home } from './Home'
import { WafersTable } from './Wafers'

const Edit = (props) => {
  const {
    open,
    handleclose,
    data,
    setRender,
    render,
    handleRender,
    setLoading,
    setData,
    dataBefore,
  } = props
  const createDismissableSnackbar = useCustomSnackbar()

  const { state, setOpen, setClose } = SetState()
  const [edit] = useContext(EditContext)
  const [formEdit, setFormEdit] = useState(data.wafers)
  const [dataInfo, setDataInfo] = useState(data.details)

  const handleWafersChange = (newWafers) => {
    setFormEdit(newWafers)
    setData((prev) => ({
      ...prev,
      wafers: newWafers,
    }))
  }

  const handleDelete = async () => {
    setLoading(true)
    await interfaces.wafersWithControlInterface
      .deleteVeh(data.details.id)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
        handleclose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setLoading(false)
    setClose()
  }

  const handleSubmit = async () => {
    const body = {}

    if (dataInfo.observacion !== data.details.observacion) {
      body.vehiculo = { observacion: dataInfo.observacion }
    }

    if (JSON.stringify(formEdit) !== JSON.stringify(data.wafers)) {
      body.wafers = formEdit
    }

    await interfaces.wafersWithControlInterface.edit(data.details.id, body).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      setRender(!render)
      handleclose()
      if (handleRender) {
        handleRender()
      }
    })
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Obleas',
      color: 'primary',
    },
    {
      id: 2,
      title: 'Archivos',
      color: 'primary',
    },
    {
      id: 3,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <Home
            data={dataInfo}
            setData={setDataInfo}
            edit={edit}
            permissions={dataBefore}
            setIsLoading={setLoading}
            setRender={setRender}
            render={render}
            handleclose={handleclose}
            wafers={data.wafers}
          />
        )
      case 1:
        return (
          <WafersTable
            formEdit={formEdit}
            edit={edit}
            setFormEdit={handleWafersChange}
            data={data.wafers}
            estado={data.details.estado}
          />
        )
      case 2:
        return <Files data={dataInfo} setData={setDataInfo} />
      case 3:
        return <ComplexDialogHistory history={data.history} />
      default:
        break
    }
  }

  return (
    <>
      <ComplexDialog
        open={open}
        onClose={handleclose}
        tabs={horizontalTabs}
        title={`${dataInfo.dominio} - ${dataInfo.marca} - ${dataInfo.modelo}`}
        subtitle={
          <div>
            {`ID ${dataInfo.id} - Creado el ${dataInfo.fecha_creacion} por ${dataInfo.usuario_creador}`}
          </div>
        }
        children={renderTabs}
        actions={
          <ComplexDialogActions
            onClose={handleclose}
            handleSubmit={() => handleSubmit()}
            //canEdit={!permissions.allowEdit}
            data={{
              ...dataInfo,
              wafers: formEdit,
            }}
            editMode={true}
            leftButton={
              dataBefore.managementInterface
                ? {
                    icon: <ExitToApp fontSize="small" />,
                    title: 'Eliminar',
                    variant: 'contained',
                    disabled: false,
                    style: { background: 'rgb(244, 67, 54)', color: '#fff' },
                    onClick: () => {
                      setOpen()
                    },
                  }
                : undefined
            }
          />
        }
      />

      {state.suspense && (
        <DialogComponent
          open={state.open}
          handleclose={state.loading ? null : setClose}
          widthLarge={500}
          title="¿Desea eliminar el siguiente vehículo?"
          subtitle="¡Esta acción es irreversible!"
          disableChildHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons
              onClickSubmit={() => handleDelete()}
              disabledCancel={state.loading}
              disabledSubmit={state.loading}
              isLoading={state.loading}
            />
          }
        />
      )}
    </>
  )
}

export default Edit
